import { Component, OnInit } from '@angular/core';
import { AdminService } from '../../_services/admin.service';
import { PageCriteria } from 'src/app/_models/page-criteria';
import { HeaderData } from 'src/app/_models/header-data';
import { BehaviorSubject } from 'rxjs';
import { RESULTS_NOT_FOUND, ADMIN_UTILITY } from 'src/app/_common/product-config';
import { PsiData } from 'src/app/_models/psi-data';
import { UserType, UserStatusID, StatusCode } from '../../../_common/_enum/module.enum'; //USING IT IN HTML
import { Router } from '@angular/router';

@Component({
  selector: 'app-user-list',
  templateUrl: './user-list.component.html',
  styleUrls: ['./user-list.component.scss']
})
export class UserListComponent implements OnInit {

  resultsNotFound = RESULTS_NOT_FOUND;
  companyNameEllipsis = ADMIN_UTILITY.CompanyNameEllipsis;
  private hasCompanies: boolean = true;
  private _total$ = new BehaviorSubject<number>(0);
  private loading: boolean = false;
  private headerData:HeaderData;
  private users = [];
  private userCriteria: PageCriteria;

  private companies = [];
  private filterObj: Object[];
  private selectedCompany: any;
  private selectedStatus: any;

  private loggedInUserCompanyID = null;
  private isLoggedInUserProSight:boolean = false;

  //private killServicesOnDestroy = [];

  private resendActivationLoader = [];
  private sentActivationLoader = [];
  private failedActivationLoader = [];
  private hasAccess:boolean = false;

  private psiData:PsiData = null;

  constructor(private router:Router, private adminService: AdminService) { }

  ngOnInit() {
    this.filterObj = [
      {filterIndex: 0, displayName : 'All', value: null, group: 'UserStatus'},
      {filterIndex: 1, displayName : 'Active', value: '1', group: 'UserStatus'},
      {filterIndex: 2, displayName : 'Deactivated', value: '2', group: 'UserStatus'},
      /*{filterIndex: 3, displayName : 'On Hold', value: '3', group: 'UserStatus'},*/
      {filterIndex: 4, displayName : 'Pending Activation', value: '4', group: 'UserStatus'},
      /*{filterIndex: 5, displayName : 'Expired', value: '5', group: 'UserStatus'},
      {filterIndex: 6, displayName : 'Reset', value: '6', group: 'UserStatus'},*/
    ];
    this.userCriteria = new PageCriteria();
    this.selectedStatus = this.filterObj.find((obj:any) => {return obj.group == 'UserStatus' && obj.displayName == 'All'});
    this.selectedCompany = {companyID:null, companyName: "All"};

    this.psiData = this.adminService.getData();
    this.loggedInUserCompanyID = (this.psiData && this.psiData.currentUser)? this.psiData.currentUser.companyID : null;
    this.isLoggedInUserProSight = this.psiData.currentUser.userType === UserType.ProSight;

    /* Setting Headers Starts */
    this.headerData = new HeaderData();
    this.setHeaderData();
    /* Setting Headers Ended */

    this.resetCriteria();
    if(this.isLoggedInUserProSight){
      this.loading = true;
      this.fetchCompanies();
    }else{
      this.companies = [{companyID:null, companyName: "All"}];
      this.selectedCompany = this.companies[0];
      this.filterUsers();
    }
  }

  get UserStatusIDEnum(){
    return UserStatusID;
  }
  
  getUserStatusClass(status){
    return (status.toLowerCase() === "pending activation")?"pending-activation":(status.toLowerCase() === "on hold")?"on-hold":status.toLowerCase();
  }

  setHeaderData(){
    this.headerData.pageTitle = "Users";//.toLowerCase();
    this.headerData.breadcrumb = [{itemName: "ADMIN", itemLink: "/admin"}];

    this.adminService.header = this.headerData;
  }
  fetchCompanies(){
    let fetchCompaniesSubscription = this.adminService.findProducersByCompany().subscribe((companies:any) => {
      this.companies = companies;
      this.companies.unshift({companyID:null, companyName: "All"});
      this.selectedCompany = this.companies.find((_company)=> _company.companyID == this.loggedInUserCompanyID);
      this.filterUsers();
    },error=>{
      this.hasAccess = !(error.status == StatusCode.NoAccess);
    });

    this.adminService.runningServices.push(fetchCompaniesSubscription);
  }
  fetchUsers(){
    this.loading = true;
    let fetchUsersSubscription = this.adminService.fetchUsers(this.userCriteria).subscribe((users:any) => {
      this.loading = false;
      this._total$.next(users.length);
      this.users = users;
      this.hasCompanies = users.length>0;
      console.log(this._total$);
    },error=>{
      this.loading = false;
      this.hasAccess = !(error.status == StatusCode.NoAccess);
    });

    this.adminService.runningServices.push(fetchUsersSubscription);
  }

  filterUsers(item = null, type = null){
    if(type == 'company'){
      this.selectedCompany = item;
    }else if(type == this.selectedStatus.group){
      this.selectedStatus = item;
    }
    this.userCriteria.filterBy = [];
    if(this.selectedCompany && this.selectedCompany.companyID != null){
      this.userCriteria.filterBy.push({
        "FilterColumnName": "CompanyID",
        "FilterValue": this.selectedCompany.companyID
      });
    }
    if(this.selectedStatus && this.selectedStatus.value != null){
      this.userCriteria.filterBy.push({
        "FilterColumnName": "StatusID",
        "FilterValue": this.selectedStatus.value
      });
    }

    this.userCriteria.pageNo = 1;
    this.fetchUsers();
  }

  resendActivationEmail(_user){
    if(_user.statusID == UserStatusID.PendingActivation){
      this.resendActivationLoader.push(_user.emailID);
      this.adminService.resendActivationEmail(_user.emailID).subscribe(data=>{
        this.resendActivationLoader.splice(this.resendActivationLoader.indexOf(_user.emailID),1);
        if(data){
          this.sentActivationLoader.push(_user.emailID);
        }else{
          this.failedActivationLoader.push(_user.emailID);
        }
        setTimeout(()=>{
          this.sentActivationLoader.splice(this.sentActivationLoader.indexOf(_user.emailID),1);
          this.failedActivationLoader.splice(this.failedActivationLoader.indexOf(_user.emailID),1);
        }, 3000);
      },
      error => {
        this.resendActivationLoader.splice(this.resendActivationLoader.indexOf(_user.emailID),1);
        console.log("Resend Activation email Error : "+ error);
      });
    }
  }
  goToCreateUser(){
    this.router.navigateByUrl("admin/user/new");
  }
  get total$() { return this._total$.asObservable(); }

  resetCriteria(){
    this.userCriteria.filterBy = [{
      "FilterColumnName": "CompanyID",
      "FilterValue": this.loggedInUserCompanyID
    }];
    this.userCriteria.pageNo = 1;
    this.userCriteria.sortBy = "FirstName";
    this.userCriteria.sortOrder = "asc";
    this.userCriteria.filterBy = [];
  }

  onPageChange(){
    window.scrollTo(0, 0);
  }
  
  ngOnDestroy() {
    this.adminService.runningServices.forEach(subscription =>subscription.unsubscribe());
  }
}
